import { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ArrowIcon from './ArrowIcon'

const Button = styled.button`
  width: auto;
  margin: 12px;
  position: absolute;
  z-index: 1;
  background: transparent;
  cursor: pointer;
  ${({ type }) => type === 'previous' && 'left: 0'};
  ${({ type }) => type === 'next' && 'right: 0'};
`

const SlideButtons = ({ onButtonClick, iconSize = 42 }) => {
  const nextButton = useRef()

  useEffect(() => {
    if (nextButton.current) {
      nextButton.current.focus()
    }
  }, [])

  return (
    <>
      <Button
        onClick={() => {
          onButtonClick(-1)
        }}
        type={'previous'}
        aria-label="Föregående bild"
      >
        <ArrowIcon width={iconSize} height={iconSize} previous={true} />
      </Button>
      <Button
        ref={nextButton}
        onClick={() => {
          onButtonClick(1)
        }}
        type={'next'}
        aria-label="Nästa bild"
      >
        <ArrowIcon width={iconSize} height={iconSize} previous={false} />
      </Button>
    </>
  )
}

SlideButtons.propTypes = {
  onButtonClick: PropTypes.func.isRequired,
  iconSize: PropTypes.number,
}

export default SlideButtons
